import { render, staticRenderFns } from "./DashAlertsAndMore.vue?vue&type=template&id=0efed814"
import script from "./DashAlertsAndMore.vue?vue&type=script&lang=js"
export * from "./DashAlertsAndMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports